import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../../lib/siteData";

export const Services = () => {
  return (
    <section
      id="services"
      className="relative bg-[#080D0A] py-28 md:py-40 border-t border-[#223026]"
      data-testid="services-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <span className="text-sm uppercase tracking-[0.2em] text-lime-400 font-bold">
              What We Do
            </span>
            <h2 className="font-display font-bold tracking-tight text-4xl md:text-6xl text-white mt-4 leading-none max-w-2xl">
              Heavy work, <br /> handled clean.
            </h2>
          </div>
          <p className="text-neutral-400 max-w-sm text-base md:text-lg">
            Six core services covering everything from raw brush to a finished,
            buildable lot.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-[#223026]">
          {SERVICES.map((s, i) => (
            <motion.a
              key={s.id}
              href="#estimate"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
              className="group relative border-r border-b border-[#223026] p-8 md:p-10 min-h-[300px] flex flex-col justify-between overflow-hidden"
              data-testid={`service-card-${s.id}`}
            >
              <div
                className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 grayscale"
                style={{
                  backgroundImage: `linear-gradient(to top, rgba(10,10,10,0.92), rgba(10,10,10,0.55)), url(${s.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              />
              <div className="relative z-10 flex items-start justify-between">
                <span className="font-mono text-sm text-neutral-500 group-hover:text-lime-400 transition-colors">
                  0{i + 1}
                </span>
                <ArrowUpRight
                  size={22}
                  className="text-neutral-600 group-hover:text-lime-400 group-hover:rotate-0 -rotate-45 transition-all duration-300"
                />
              </div>
              <div className="relative z-10">
                <h3 className="font-display font-semibold text-2xl md:text-3xl text-white tracking-tight">
                  {s.title}
                </h3>
                <p className="text-neutral-400 text-sm md:text-base mt-3 leading-relaxed max-w-xs">
                  {s.desc}
                </p>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};
